module.exports = __webpack_public_path__ + "static/media/22.intellij-idea.e34c93ff.svg";